import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { BackButton, Form, Header, HistoryButton } from 'shared/components'
import { useAreaTypeValidationSchema } from 'features/areaTypes/hooks/useAreaTypeValidationSchema'
import { AreaTypeFormSections } from 'features/areaTypes/organisms/AreaTypeForm/AreaTypeFormSections'
import { toAreaTypeFormData } from 'features/areaTypes/utils/toAreaTypeFormData'
import { useEditAreaTypeMutation } from './mutations/useEditAreaTypeMutation'
import { useFetchAreaType } from './queries/useFetchAreaType'
import { usePopulateAreaType } from './hooks/usePopulateAreaType'

const AreaTypePage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const validationResolver = useAreaTypeValidationSchema()

	const form = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const { handleSubmit, reset, resetField } = form

	const { boothType } = useFetchAreaType()

	const originalImage = usePopulateAreaType({
		data: boothType?.data,
		reset,
		resetField
	})

	const { editAreaTypeMutation, isEditAreaTypeLoading } = useEditAreaTypeMutation()

	return (
		<>
			<Header
				title={t('Edit area type')}
				eyebrow={t('Booking engine')}
				actions={
					<>
						<BackButton to={routes.areaTypeIndex} text={t('Back to area types')} />
						<HistoryButton to={routes.areaTypeHistory(params.id)} />
					</>
				}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Save changes')}
					cancelText={t('Discard changes')}
					onCancel={() => reset()}
					onSubmit={handleSubmit((data) =>
						editAreaTypeMutation(toAreaTypeFormData(data, data.image !== originalImage))
					)}
					isLoading={isEditAreaTypeLoading}>
					<AreaTypeFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default AreaTypePage
